export default {
  top_email_label: 'Din e-mail',
  choose_language_label: 'Välj ditt språk',
  empty_bag_info: 'Du har inga produkter i varukorgen',
  empty_bag_button_label: 'Tillbaka till butiken',
  minicart_label: 'Varukorg',
  expire_error_message: '',
  ingrid_not_available_error: 'Tyvärr kan vi inte leverera till denna adressen',
  error_header: 'Något gick fel',
  default_error_message: 'Försök ladda om sidan eller kontakta oss om problemet kvarstår',
  product_not_found: '',
  voucher_not_found: 'Angiven kod finns inte',
  voucher_limit_message: '',
  unavailable_items: 'Följande produkter är tillfälligt slut',
  unavailable_items_info: 'Tog bort {quantity} × {product}',
  country_mismatch: '',
  address_shipping_note: 'Din beställning skickas automatiskt till leveransadressen som är registrerad i ditt PayPal-konto',
  paypal_note: 'Använd samma land adress när du går till ditt PayPal-konto för att undvika onödiga kassafel',
  payment_method_failed: 'Vi är ledsna.',
  selection_not_found: 'Något gick fel',
  required_valid_error: 'Detta fält är obligatoriskt',
  passwords_match_valid_error: 'Lösenordet måste matcha',
  email_valid_error: 'Ange korrekt e-post',
  personnummer_valid_error: 'Ogiltigt format (ÅÅMMDDXXXX)',
  phone_valid_error: 'Ange korrekt mobilnummer',
  min_length_error: 'Måste vara {min} tecken eller mer',
  max_length_error: 'Måste vara {max} tecken eller mindre',
  alphanumeric_valid_error: 'Detta fält accepterar endast bokstäver och specialtecken',
  shipping_step_title: 'Leverans',
  payment_step_title: 'Betalning',
  payment_step_message: 'Alla transaktioner är säkra och krypterade och vi sparar aldrig dina kreditkortsuppgifter',
  payment_group_title: 'Betalningsalternativ',
  payment_handling_cost_label: 'Hanteringskostnad: {handlingCost}',
  address_step_title: 'Personlig information',
  shipwallet_step_title: 'Leverans',
  step_edit: 'Ändra',
  shipping_step_button_title: 'Fortsätt till betalning',
  address_step_button_title: 'Fortsätt',
  shipwallet_step_button_title: 'Fortsätt till betalning',
  shop_working_hours_info: 'Notera att vi öppnar kl 11.00. Beställningar levereras mellan kl 11:00-12:00',
  shipwallet_step_readonly_label: 'Frakt',
  ingrid_fields_step_title: 'Leveransadress',
  information_header_label: 'Checkout information',
  information_button_label: 'OK, jag förstår',
  shop_more_button_label: 'Fortsätt handla',
  cart_label: 'Din varukorg',
  checkout_button_label: 'Till kassan',
  close_cart_button_label: 'Stäng',
  cart_separator_text: 'eller',
  cart_wallet_klarna_checkout_label: 'Betala med Klarna',
  voucher_group_label: 'Voucher',
  voucher_locked_text: '',
  voucher_switch_button_label: 'Använd rabattkod',
  voucher_apply_button_label: 'Lägg till',
  voucher_remove_button_label: 'Ta bort',
  voucher_input_label: 'Presentkort eller rabattkod',
  voucher_input_placeholder: 'Presentkort eller rabattkod',
  pin_fetch_button_label: 'Hämta',
  pin_input_label: 'Personnummer',
  pin_input_placeholder: 'Personnummer',
  pin_not_found_error_message: 'Hittade inte Personnummer',
  show_more_products_button_label: 'Se alla {itemsLength} produkter',
  show_less_products_button_label: 'Göm produkter',
  total_price_message: '{grandTotalPrice} totalt',
  order_summary_label: 'Din order',
  open_order_label: 'Order ({grandTotalPrice})',
  close_order_label: 'Tillbaka till kassan',
  order_address_name: '',
  order_address_company: '',
  order_address_address: '',
  order_address_city: '',
  order_address_zipcode: '',
  order_address_country: '',
  gift_wrap_switch_button_label: 'Presentinslagning',
  current_location_denited_label: 'Tillgång till din plats är blockerad av dina webbläsarinställningar',
  current_location_label: 'Använd aktuell plats',
  fetching_current_location_label: 'Hämtar adress...',
  country_label: 'Land',
  country_dropdown_placeholder: 'Välja land...',
  state_label: 'Stat',
  state_dropdown_placeholder: 'Välja stat...',
  first_name_label: 'Förnamn',
  first_name_placeholder: 'Förnamn',
  last_name_label: 'Efternamn',
  company_placeholder: 'Företag',
  company_label: 'Företag',
  last_name_placeholder: 'Efternamn',
  email_label: 'E-post',
  email_placeholder: 'E-post',
  phone_number_label: 'Mobilnummer',
  phone_number_placeholder: 'Mobilnummer',
  address_1_label: 'Adress',
  address_1_placeholder: 'Adress',
  address_2_label: 'Adress 2',
  address_2_placeholder: 'Adress 2',
  houseNumber_placeholder: 'Dörrkod etc.',
  houseNumber_label: 'Dörrkod etc.',
  zip_code_label: 'Postnummer',
  zip_code_placeholder: 'Postnummer',
  city_label: 'Stad',
  city_placeholder: 'Stad',
  personal_number_label: 'Personnummer',
  personal_number_placeholder: 'Personnummer',
  ship_to_different_label: 'Skicka till en annan adress',
  remember_me_label: 'Kom ihåg mig på den här enheten',
  consent_group_title: 'Jag godkänner villkoren',
  terms_and_conditions_label: 'Jag godkänner allmänna',
  terms_and_conditions_link_label: 'villkor',
  newsletter_checkbox_label: 'Jag vill få erbjudanden och nyheter',
  newsletter_checkbox_link_label: 'Villkor',
  subtotal_label: 'Summa artiklar',
  shipping_label: 'Fraktalternativ',
  shipping_sumary_label: 'Fraktavgift',
  payment_handling_label: 'Hanteringskostnad',
  newsletter_label: '',
  tax_deducted_label: 'Skatteavdrag',
  countdown_label: ' kvar till fri hemleverans!',
  countdown_100_percent_label: 'Fri hemleverans',
  total_label: 'Totalt inkl. moms',
  including_tax_label: 'Varav {taxPercent}% moms',
  discount_label: 'Rabatt',
  order_details_label: 'Orderdetaljer',
  order_number_label: 'Ordernummer:',
  order_date_label: 'Orderdatum:',
  order_status_label: 'Orderstatus:',
  payment_method_receipt_title: 'Betalning:',
  delivery_method_receipt_title: 'Leverans:',
  shipping_address_receipt_title: 'Leveransadress:',
  ingrid_info_receipt_title: 'Leveransadress',
  print_receipt_label: 'Skriv ut kvitto',
  bought_items_label: 'Produkter du köpt',
  order_summary_receipt_title: 'Ordersummering',
  thank_message: 'Tack för ditt köp!',
  additional_notes_label: 'Skriv dina önskemål här',
  additional_notes_placeholder: 'Skriv dina önskemål här',
  place_order_button_label: 'Slutför köp',
  place_order_button_paypal_label: 'Betala med PayPal',
  contact_group_title: 'Kontaktuppgifter',
  customer_information_group_title: 'Kundinformation',
  shipping_country_group_title: 'Leveransland',
  shipping_address_group_title: 'Leveransadress',
  billing_address_group_title: 'Fakturaadress',
  order_message_group_title: 'Lämna ett meddelande med din order',
  billing_address_checkbox_label: 'Samma som leveransadressen',
  billing_address_receipt_title: 'Fakturaadress',
  continue_shopping_receipt_link_label: 'Fortsätt handla',
  membership_no_orders_message: '',
  membership_no_checks_message: '',
  membership_available_checks: '',
  membership_used_checks: '',
  membership_register_error_email: '',
  customer_not_fount: 'Vi kunde inte identifiera dig till den givna emailaddressen',
  email_required_message: '',
  membership_register_error_other: '',
  membership_login_error_password: '',
  membership_password_reset_link_expire_error: '',
  membership_tabs_personal: '',
  membership_tabs_checks: 'Checkar',
  membership_tabs_password: '',
  membership_tabs_orders: '',
  membership_personal_data_title: '',
  membership_personal_data_subtitle: '',
  membership_change_password_title: '',
  membership_change_password_subtitle: '',
  membership_forgot_password_title: '',
  membership_forgot_password_subtitle: '',
  membership_recovery_password_title: '',
  membership_recovery_password_subtitle: '',
  membership_login_title: '',
  membership_login_subtitle: '',
  membership_orders_history_title: '',
  membership_orders_history_subtitle: '',
  membership_checks_subtitle: '',
  membership_check_voucher_code_label: '',
  membership_check_discount_label: '',
  membership_check_data_valid_label: '',
  membership_check_data_used_label: '',
  membership_points_balance_label: '',
  membership_firstname_placeholder: 'Förnamn',
  membership_firstname_label: 'Förnamn',
  membership_lastname_placeholder: 'Efternamn',
  membership_lastname_label: 'Efternamn',
  membership_address1_placeholder: 'Adress',
  membership_address1_label: 'Adress',
  membership_address2_placeholder: 'Adress 2',
  membership_address2_label: 'Adress 2',
  membership_country_placeholder: 'Välja land...',
  membership_country_label: 'Land',
  membership_city_placeholder: 'Stad',
  membership_city_label: 'Stad',
  membership_state_placeholder: 'Välja stat...',
  membership_state_label: 'Stat',
  membership_zipcode_placeholder: 'Postnummer',
  membership_zipcode_label: 'Postnummer',
  membership_email_placeholder: 'E-post',
  membership_email_label: 'E-post',
  membership_phone_placeholder: 'Mobilnummer',
  membership_phone_label: 'Mobilnummer',
  membership_password_placeholder: '',
  membership_password_label: '',
  membership_show_password_tooltip: '',
  membership_password_confirm_placeholder: '',
  membership_password_confirm_label: '',
  membership_new_password_placeholder: '',
  membership_new_password_label: '',
  membership_new_password_save: '',
  membership_password_recovery: '',
  membership_identity_number_placeholder: 'Personn​ummer',
  membership_identity_number_label: 'Personn​ummer (ÅÅMMDDXXXX)',
  membership_physical_store_placeholder: '',
  membership_physical_store_label: '',
  membership_register_continue_button_label: '',
  membership_save: '',
  membership_update: 'Uppdatera',
  membership_login_button_label: '',
  membership_back_to_login: '',
  membership_logout: '',
  membership_forgotten_password: '',
  membership_not_your_account: '',
  membership_continue_as_guest: '',
  membership_continue: '',
  membership_start: '',
  membership_greeting: 'Hello',
  membership_close_overlay: '',
  membership_show_more: '',
  membership_order_status: '',
  membership_order_delivery: '',
  membership_order_summary_title: 'Ordersummering',
  membership_account_subtitle: 'Here you can manage your account',
  notifications_recovery_success: '',
  notifications_change_success: '',
  notifications_update_success: '',
  membership_gender_female: 'Kvinna',
  membership_gender_male: 'Man',
  membership_personal_information_group_title: 'Personlig information',
  membership_gender_label: 'Kön',
  membership_gender_placeholder: 'Välja kön',
  membership_dob_label: 'Födelsedatum',
  membership_dob_placeholder: 'Födelsedatu',
  ingrid_address_label: '',
  ingrid_carrier_label: '',
  ingrid_name_label: '',
  ingrid_city_label: '',
  ingrid_zipcode_label: '',
  ingrid_estimated_delivery_time_label: '',
  ingrid_doorcode: '',
  remove_button_label: '',
};
